import angular from 'angular';
import mcButton from './mcButton';
import './style.scss';

export default angular
  .module('components.mcButton', [])
  .component('mcButton', mcButton).name;
